import React from 'react';
export var CommentContext = React.createContext({
    comment: {},
    isEditing: false,
    isReplying: false,
    isPeeking: false,
    canShowActionMenu: false,
    isCommentVisible: true,
    setEditingState: function () { return null; },
    setCanShowActionMenu: function () { return null; },
    setPeeking: function () { return null; },
});
CommentContext.displayName = 'CommentContext';
//# sourceMappingURL=CommentContext.js.map